import React from 'react';
import { EXPORT_TYPE } from '@src/constants/presentation';
import AudioFileIcon from '@src/assets/icons/project-normal.svg';
import PresentationFileIcon from '@src/assets/icons/project-presentation.svg';
import SrtFileIcon from '@src/assets/icons/project-srt.svg';
import VideoFileIcon from '@src/assets/icons/project-video.svg';

// The project list already ships this icon set: the same 32px document shape as
// the export panel design, one glyph per file type.
const ICONS = {
  [EXPORT_TYPE.VIDEO]: VideoFileIcon,
  [EXPORT_TYPE.PPTX]: PresentationFileIcon,
  [EXPORT_TYPE.JOIN_AUDIO]: AudioFileIcon,
  [EXPORT_TYPE.SEPARATE_AUDIO]: AudioFileIcon,
  [EXPORT_TYPE.AUDIO_SRT]: AudioFileIcon,
  [EXPORT_TYPE.SRT]: SrtFileIcon,
};

const ExportFileTypeIcon = ({ type }) => (
  <img src={ICONS[type] || AudioFileIcon} alt="" />
);

export default ExportFileTypeIcon;
